import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class CatalogsService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  getCategories() {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}categories?lang=${lang}`);
  }

  getMunicipality() {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}municipalities?lang=${lang}`);
  }
  
  create(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/create/catalog?lang=${lang}`, data);
  }

  update(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/update/catalog?lang=${lang}`, data);
  }

  deletePage(id: number = 0){
    return this.http.post(`${environment.apiUrl}admin/delete/catalog`, { id });
  }

}
